import { AxiosResponse } from 'axios';
import { apiClient } from '../config/httpClient';

export class UbicacionService {
    obtenerProvincia(poblacion: string): Promise<AxiosResponse<{ provincia: string | null }>> {
        return apiClient.get<{ provincia: string | null }>('/ubicacion/provincia', {
            params: { poblacion }
        });
    }
}

export const ubicacionService = new UbicacionService();
